export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6106.5fa15775.jpg";